module.exports = __webpack_public_path__ + "img/120-55-flat.380b6dad.jpg";